import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  createDiscipline,
  deleteDiscipline,
  getDiscipline,
  getDisciplines,
  getDisciplinesMasterData,
  updateDiscipline
} from '../../../api/disciplines';

export const getDisciplinesAsync = createAsyncThunk(
  'disciplines/getDisciplines',
  getDisciplines
);

export const getDisciplinesMasterDataAsync = createAsyncThunk(
  'disciplines/getDisciplinesMasterData',
  getDisciplinesMasterData
);

export const getDisciplineAsync = createAsyncThunk(
  'disciplines/getDiscipline',
  getDiscipline
);

export const createDisciplineAsync = createAsyncThunk(
  'disciplines/createDiscipline',
  createDiscipline
);

export const updateDisciplineAsync = createAsyncThunk(
  'disciplines/updateDiscipline',
  updateDiscipline
);

export const deleteDisciplineAsync = createAsyncThunk(
  'disciplines/deleteDiscipline',
  deleteDiscipline
);

export interface Discipline {
  id: number;
  name: string;
  cfihosName: string | null;
}

interface DisciplineState {
  data: Discipline[];
  masterData: Discipline[];
  count: number;
  selectedDiscipline: Discipline | null;
}

const initialState: DisciplineState = {
  data: [],
  masterData: [],
  count: 0,
  selectedDiscipline: null
};

export default createSlice({
  name: 'disciplines',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getDisciplinesAsync.fulfilled, (state, action) => {
      state.data = action.payload.data;
    });
    builder.addCase(
      getDisciplinesMasterDataAsync.fulfilled,
      (state, action) => {
        state.masterData = action.payload.data;
        state.count = action.payload.count;
      }
    );
    builder.addCase(getDisciplineAsync.fulfilled, (state, action) => {
      state.selectedDiscipline = action.payload;
    });
  }
});
